import { Experiments } from '@src/constants/abTest';

import { useTestVariant } from './useTestVariants';

export function useAbSeaExperiment() {
  const { isBVariant } = useTestVariant(Experiments.EXCLUDE_FULLDEAL_OFFERS);

  return { isSeaExcludeFeatureExperiment: isBVariant };
}
